import React from 'react'
import ConnectedInlineMessage from 'uiComponents/messages/connectedInlineMessage'
import { useShowConviousStudyInfo } from './infoNotificationHook'
import './notification.scss'

const GeneralNotifications = () => {
    useShowConviousStudyInfo()

    return (
        <div className="general-notifications">
            <div style={{ maxWidth: '50vw' }}>
                <ConnectedInlineMessage tag="general" />
            </div>
        </div>
    )
}

export default GeneralNotifications
